(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.itemsList = this.querySelector('[data-cart-items]');
        this.emptyState = this.querySelector('[data-cart-empty]');
        this.footer = this.querySelector('[data-cart-footer]');
        this.subtotal = this.querySelector('[data-cart-subtotal]');
        this.status = this.querySelector('[data-cart-status]');
        this.template = document.getElementById('cart-drawer-item-template');

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });

        this.querySelectorAll('[data-cart-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );

        this.itemsList.addEventListener('click', (event) => this.handleItemClick(event));

        document.addEventListener('click', (event) => {
          if (event.target.closest('[data-cart-open]')) {
            event.preventDefault();
            this.open();
          }
        });

        document.addEventListener('bff:cart:add', (event) => this.addItem(event.detail));

        this.refresh();
      }

      open() {
        if (!this.dialog.open) this.dialog.showModal();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      announce(message) {
        if (this.status) this.status.textContent = message;
      }

      formatMoney(cents, currency) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      async refresh() {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        this.render(cart);
        return cart;
      }

      render(cart) {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });

        const hasItems = cart.items.length > 0;
        this.emptyState.hidden = hasItems;
        this.footer.hidden = !hasItems;
        this.itemsList.innerHTML = '';

        cart.items.forEach((item) => {
          const node = this.template.content.firstElementChild.cloneNode(true);
          const image = node.querySelector('.cart-item__media img');
          const mediaLink = node.querySelector('.cart-item__media');
          const title = node.querySelector('.cart-item__title');
          const variant = node.querySelector('.cart-item__variant');
          const price = node.querySelector('.cart-item__price');
          const quantityValue = node.querySelector('[data-quantity-value]');

          node.dataset.key = item.key;

          if (item.image) {
            image.src = `${item.image}${item.image.includes('?') ? '&' : '?'}width=200`;
            image.alt = item.product_title;
          }
          mediaLink.href = item.url;
          title.href = item.url;
          title.textContent = item.product_title;
          variant.textContent = item.variant_title || '';
          variant.hidden = !item.variant_title;
          price.textContent = this.formatMoney(item.final_line_price, cart.currency);
          quantityValue.textContent = item.quantity;

          this.itemsList.appendChild(node);
        });

        this.subtotal.textContent = this.formatMoney(cart.total_price, cart.currency);
      }

      handleItemClick(event) {
        const row = event.target.closest('.cart-item');
        if (!row) return;
        const key = row.dataset.key;
        const quantityValue = row.querySelector('[data-quantity-value]');
        const currentQuantity = Number(quantityValue.textContent);

        if (event.target.closest('[data-quantity-increase]')) {
          this.changeQuantity(key, currentQuantity + 1);
        } else if (event.target.closest('[data-quantity-decrease]')) {
          this.changeQuantity(key, Math.max(0, currentQuantity - 1));
        } else if (event.target.closest('[data-cart-remove]')) {
          this.changeQuantity(key, 0);
        }
      }

      async changeQuantity(key, quantity) {
        this.announce('Updating bag…');
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        const cart = await response.json();
        this.render(cart);
        this.announce('Bag updated');
      }

      async addItem(detail) {
        this.announce('Adding to bag…');
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: detail.id, quantity: detail.quantity || 1 }] }),
          });
          const result = await response.json();
          if (!response.ok) {
            this.announce(result.description || 'Couldn’t add that to your bag.');
            document.dispatchEvent(new CustomEvent('bff:cart:error', { detail: result }));
            return;
          }
          await this.refresh();
          this.announce('Added to bag');
          this.open();
          document.dispatchEvent(new CustomEvent('bff:cart:added', { detail: result }));
        } catch (error) {
          this.announce('Couldn’t add that to your bag.');
        }
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    if (!window.bffRevealInit) {
    window.bffRevealInit = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    const observeReveals = (root = document) => {
      root.querySelectorAll('[data-reveal]').forEach((element) => {
        if (reducedMotion) {
          element.classList.add('is-visible');
        } else {
          revealObserver.observe(element);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observeReveals());
    } else {
      observeReveals();
    }

    document.addEventListener('shopify:section:load', (event) => observeReveals(event.target));
  }
  } catch(e) { console.error(e); }
})();

})();
